export default "__VITE_ASSET__BFlMnf9E__"